import React from 'react';
import { SeoHead } from './components/SeoHead';
import { DgptHeader } from './components/dgpt/DgptHeader';
import { HeroSection } from './components/dgpt/HeroSection';
import { LogoStrip } from './components/dgpt/LogoStrip';
import { MoatSection } from './components/dgpt/MoatSection';
import { FlywheelSection } from './components/dgpt/FlywheelSection';
import { IntelligenceLayers } from './components/dgpt/IntelligenceLayers';
import { ProductStory } from './components/dgpt/ProductStory';
import { QuestionsSection } from './components/dgpt/QuestionsSection';
import { LifecycleSection } from './components/dgpt/LifecycleSection';
import { SpeedSection } from './components/dgpt/SpeedSection';
import { SecuritySection } from './components/dgpt/SecuritySection';
import { CustomersSection } from './components/dgpt/CustomersSection';
import { GenerationsSection } from './components/dgpt/GenerationsSection';
import { FinalCta } from './components/dgpt/FinalCta';
import { DgptFooter } from './components/dgpt/DgptFooter';
import { MobileStickyCta } from './components/dgpt/MobileStickyCta';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-text-primary antialiased" data-id="element-0" data-mp="3mkhmvvd9p66k">
      <SeoHead data-id="element-1" data-mp="3rbznujfaj6rj" />
      <DgptHeader data-id="element-2" data-mp="3rdkgg3i1ofmr" />
      <main id="main" data-id="element-3" data-mp="3rd19fhtxnbni">
        <HeroSection data-id="element-4" data-mp="5yk6vxnnffx" />
        <LogoStrip data-id="element-5" data-mp="6hp9c27i9cj" />
        <MoatSection data-id="element-6" data-mp="4wwnrzgd0hb" />
        <FlywheelSection data-id="element-7" data-mp="56nfhsbnbo2" />
        <IntelligenceLayers data-id="element-8" data-mp="7sxbo2oq39g" />
        <ProductStory data-id="element-9" data-mp="2zllijblcf2rh" />
        <QuestionsSection data-id="element-10" data-mp="2zmeo498kfm81" />
        <LifecycleSection data-id="element-11" data-mp="2zn6b4vo3kbmp" />
        <SpeedSection data-id="element-12" data-mp="33mf25srr5vek" />
        <SecuritySection data-id="element-13" data-mp="33lx0ggmbmoz9" />
        <CustomersSection data-id="element-14" data-mp="33n6xr3lcnt4u" />
        <GenerationsSection data-id="element-15" data-mp="33oi1j3esp0vy" />
        <FinalCta data-id="element-16" data-mp="38l8gtoirzsgb" />
      </main>
      <DgptFooter data-id="element-17" data-mp="38l017ov9q91f" />
      <MobileStickyCta data-id="element-18" data-mp="38kgnylgkc8tq" />
    </div>;
}